<template>
  <Popup title="报警器状态" minHeight="100%" ref="popup">
    <div class="item" v-for="item in statusData" :key="item.eqId">
      <van-cell title="客户名称" :value="item.companyName" />
      <van-cell title="地址" :value="item.address" />
      <van-cell title="电话" :value="item.phoneNum" />
      <van-cell title="报警器编号" :value="item.eqId" />
      <van-cell title="报警器名称" :value="item.eqName" />
      <van-cell title="报警器位置" :value="item.eqPosition" />
      <van-cell title="检测气体" :value="item.gasTypeName" />
      <van-cell title="当前状态" :value="item.eqStatusName">
        <template #right-icon>
          <van-icon
            style="margin-left: 10px"
            :color="item.eqStatusName === '上线' ? 'green' : 'red'"
            :name="item.eqStatusName === '上线' ? 'checked' : 'warning'"
          />
        </template>
      </van-cell>
      <van-cell title="生产厂家" :value="item.eqUnitName" />
      <van-cell title="生产日期" :value="item.makeDate" />
    </div>
    <empty v-if="!statusData.length" />
  </Popup>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'AlarmStatus', // 报警器状态
  setup() {
    const popup = ref(null)
    const statusData = ref([])
    const showPopup = (data) => {
      console.log(data)
      statusData.value = data
      popup.value.showPopup()
    }

    return {
      popup,
      showPopup,
      statusData
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 20px;
}
.van-cell {
  align-items: center;
}
</style>
